import { useEffect } from 'react'
import { useDropzone } from 'react-dropzone'

import { Spinner } from '..'
import { UIStage, useUpload } from './context'

export const FileDrop = () => {
  const { state, onDrop, setFileError, handleReset } = useUpload()

  const { getRootProps, getInputProps, isDragActive, fileRejections } =
    useDropzone({
      onDrop,
      accept: { 'text/csv': ['.csv'] },
      maxFiles: 1,
    })

  useEffect(() => {
    if (fileRejections.length > 0) {
      setFileError('File type not supported')
    }
  }, [fileRejections.length, setFileError])

  useEffect(() => {
    let timeout: NodeJS.Timeout
    if (state.fileError) {
      timeout = setTimeout(() => {
        handleReset()
      }, 3000)
    }
    return () => {
      timeout && clearTimeout(timeout)
    }
  }, [handleReset, state.fileError])

  return (
    <>
      <div
        {...getRootProps()}
        className={`border-dashed border-2 rounded-lg cursor-pointer p-10 flex justify-center items-center text-xl h-56   ${
          state.fileError
            ? 'border-orange-500 text-orange-500'
            : 'border-gray-500 transition-colors duration-1000'
        }`}
      >
        {state.stage === UIStage.PROCESSING && (
          <>
            <Spinner size={2} />
            {state.uploadData && (
              <span>Uploading {state.uploadData?.length ?? 0} rows...</span>
            )}
          </>
        )}
        {(state.stage === UIStage.READY ||
          state.stage === UIStage.FILE_ERROR) && (
          <>
            {!state.fileError && (
              <>
                <input {...getInputProps()} />
                {isDragActive ? (
                  <span>Drop the file here...</span>
                ) : (
                  <span>
                    Drag and drop a file here, or click to select a file
                  </span>
                )}
              </>
            )}
            {state.fileError && <span>{state.fileError}</span>}
          </>
        )}
      </div>
    </>
  )
}
